export enum HttpQueryParams {
  AccessToken = 'accessToken',
}
